export default __webpack_public_path__ + "assets/images/pricing/0b530eae17a6566632d9be37a5ae8f0c.png";